module.exports = __webpack_public_path__ + "static/media/galaxy.663bcbdd.png";